<div id="progress-wrapper" class="pt-5">
  @let steps = config.data.steps();
  @for (step of steps; track step) {
    <div class="progress-item">
      <div class="progress-item-icon">
        <!-- Icons -->
        <!-- Skipped -->
        @if (step.state == 'skipped') {
          <svg width="48" height="48" viewBox="-24,-24,48,48">
            <g
              fill="none"
              stroke="#7e7e7e"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="miter"
              stroke-miterlimit="4"
              stroke-dasharray=""
            >
              <circle cx="0" cy="0" r="23" />
              <g fill-opacity="1" fill="#ffffff">
                <path d="M-7,0h14" />
              </g>
            </g>
          </svg>
        }
        <!-- Waiting Icon -->
        @if (step.state == 'waiting') {
          <svg width="48" height="48" viewBox="-24,-24,48,48">
            <g
              fill="none"
              stroke="#7e7e7e"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="miter"
              stroke-miterlimit="4"
              stroke-dasharray="4.8,4.8"
            >
              <circle cx="0" cy="0" r="23" />
            </g>
          </svg>
        }
        <!-- Processing Icon -->
        @if (step.state == 'processing') {
          <svg width="48" height="48" viewBox="-24,-24,48,48">
            <g
              fill="none"
              stroke="#ffffff"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="miter"
              stroke-miterlimit="4"
              stroke-dasharray="4.8,4.8"
            >
              <circle cx="0" cy="0" r="23" class="rotating" />
            </g>
          </svg>
        }
        <!-- Error Icon -->
        @if (step.state == 'error') {
          <svg width="48" height="48" viewBox="-24,-24,48,48">
            <g
              fill="none"
              stroke="#f44336"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="miter"
              stroke-miterlimit="4"
              stroke-dasharray=""
            >
              <circle cx="0" cy="0" r="23" />
              <g fill-opacity="1" fill="#ffffff">
                <path d="M-7,-7l14,14" />
                <path d="M-7,7l14,-14" />
              </g>
            </g>
          </svg>
        }
        <!-- Success Icon -->
        @if (step.state == 'success') {
          <svg width="48" height="48" viewBox="-24,-24,48,48">
            <g
              fill="none"
              stroke="#4caf50"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="miter"
              stroke-miterlimit="4"
              stroke-dasharray=""
            >
              <circle cx="0" cy="0" r="23" />
              <g fill-opacity="1" fill="#ffffff">
                <path d="M-6,-1l5,5" />
                <path d="M-1,4l7,-10" />
              </g>
            </g>
          </svg>
        }
      </div>
      <!-- Has no Upload -> showing skip icon-->
      <div class="progress-item-content">
        <div class="progress-item-title">{{ step.title | translate }}</div>
        @if ((!step.showProgress || step.state != 'processing') && step.state != 'error') {
          <div class="progress-item-subtitle">{{ step.subtitle ?? '' | translate }}</div>
        }
        @if ((!step.showProgress || step.state != 'processing') && step.state == 'error') {
          <div class="progress-item-subtitle error">{{ step.subtitle ?? '' | translate }}</div>
        }
        @if (step.showProgress && step.state == 'processing') {
          <div class="progress-item-bar">
            <div class="progress-item-bar-inner" [style.width.%]="step.progress * 100"></div>
          </div>
        }
      </div>
    </div>
  }

  @if (showCloseButton()) {
    <p-button [label]="'general.close' | translate" severity="secondary" class="w-full mt-5" (onClick)="finishDialog(0)" fluid> </p-button>
  }
</div>
